import React from "react";

function SettingConfiguration() {
  return <div></div>;
}

export default SettingConfiguration;
